



























































import Vue from 'vue'
import { AddImageStates } from '@/common/constants/imageUpload'

// File size max 500MB (include 50MB)
const MAX_FILE_SIZE = 50 * 1024 * 1024

export default Vue.extend({
  data(): {
    uploadedFile: File | null
  } {
    return {
      uploadedFile: null
  }
  },
  computed: {
    uploadedFileExtension(): string {
      if (!this.uploadedFile) return ''

      const fileName = this.uploadedFile.name || ''
      const fileExtension = fileName.split('.').pop()?.toLowerCase()

      return fileExtension || ''
    },
    validFileSize(): boolean | null {
      if (!this.uploadedFile) return null
      return this.uploadedFile.size <= MAX_FILE_SIZE
    }
  },
  created() {
    window.addEventListener(
      'dragover',
      e => {
        e?.preventDefault()
      },
      false
    )
    window.addEventListener(
      'drop',
      e => {
        e?.preventDefault()
      },
      false
    )
  },
  methods: {
    dropImageHandler(e: DragEvent) {
      if (!e.dataTransfer?.files[0] ) return
      this.setUserUploadedFile(e.dataTransfer.files[0])
    },
    selectImageHandler(e: InputEvent) {
      const el = e.target as HTMLInputElement
      const fileList = el.files
      if (fileList && fileList[0]) {
        this.setUserUploadedFile(fileList[0])
      }
    },
    setUserUploadedFile(file: File) {
      this.uploadedFile = file
      this.validateAndUpload()
    },
    validateAndUpload() {
      const invalidSizeState: {[key: string]: string} = {
        'png': AddImageStates.PNG_OVER_SIZE,
        'jpeg': AddImageStates.JPEG_OVER_SIZE,
        'jpg': AddImageStates.JPEG_OVER_SIZE,
        'pdf': AddImageStates.PDF_OVER_SIZE,
        'psd': AddImageStates.PSD_OVER_SIZE,
        'ai': AddImageStates.AI_OVER_SIZE
      }
      if (invalidSizeState[this.uploadedFileExtension]) {
        if (this.validFileSize) {
          this.$emit('onSelectImage', {
            file: this.uploadedFile,
            fileExtension: this.uploadedFileExtension
          })
        } else {
          this.$emit('updateState', invalidSizeState[this.uploadedFileExtension])
        }
      } else {
        this.$emit('updateState', AddImageStates.UNSUPPORTED_FILE_FORMAT)
      }
    },
    loadImage(file: File) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = e => {
          if (!e.target) {
            reject('e.target is false')
            return
          }
          resolve(e.target.result)
        }
        reader.readAsDataURL(file)
      })
    }
  }
})
